import * as React from 'react'
import { useNavigate } from 'react-router-dom'

import { Elements } from '@stripe/react-stripe-js'
import { loadStripe } from '@stripe/stripe-js'

import { observer } from 'mobx-react'

import { useAsyncData } from 'modules/core/hooks/useAsyncData'
import Constant from 'modules/core/store/models/Constant'

import StripeForm from 'modules/billing/components/StripeForm'

interface Props {
  redirectIfFailRoute: string
}

const StripeWrapper = ({ children, redirectIfFailRoute }: React.PropsWithChildren<Props>) => {
  const [stripeKey, setStripeKey] = React.useState<string | null | undefined>(null)
  const navigate = useNavigate()

  const { loading } = useAsyncData(async () => {
    const stripeKeyConstant = new Constant({
      id: 'public_stripe_api_key'
    })

    const result = await stripeKeyConstant.fetch()

    if (result.value) {
      setStripeKey(result.value)
    } else {
      navigate(redirectIfFailRoute)
    }
  }, [])

  if (loading || !stripeKey) return null

  const stripePromise = loadStripe(stripeKey)

  return (
    <Elements stripe={stripePromise}>
      <StripeForm>{children}</StripeForm>
    </Elements>
  )
}

export default observer(StripeWrapper)
